export const STORAGE_KEY = {
  API_CONFIG: "apiConfig",
  MEDIA_SOURCE: "mediaSource",
  LIVE_CATEGORIES: "liveCategories",
  VOD_CATEGORIES: "vodCategories",
  SERIES_CATEGORIES: "seriesCategories",
  LIVE_STREAMS: "liveStreams",
  VOD_STREAMS: "vodStreams",
  SERIES_STREAMS: "seriesStreams",
  M3U_CHANNELS: "m3uChannels",
  M3U_CATEGORIES: "m3uCategories",
  EXT_EPG_URLS: "extEpgUrls",
  EXT_EPG_OFFSETS: "extEpgOffsets",
  WATCHLIST: "watchlist",
  FAVORITES: "favorites",
  HIDDEN_CATEGORIES: "hiddenCategories",
}
